import gql from 'graphql-tag';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ResponsiveImageFields on ResponsiveImage {\n  alt\n  aspectRatio\n  base64\n  height\n  sizes\n  src\n  srcSet\n  title\n  webpSrcSet\n  width\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    fragment ProjectFragment on ProjectRecord {\n  id\n  title\n  url\n  subtitle\n  cover {\n    responsiveImage(imgixParams: {ar: \"16:9\", fit: crop}) {\n      ...ResponsiveImageFields\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    query aboutStaticProps {\n  about {\n    image {\n      responsiveImage {\n        ...ResponsiveImageFields\n      }\n    }\n    knowledges {\n      title\n      entries\n    }\n    preface\n  }\n}\n    ",
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    query homeStaticProps {\n  site: _site {\n    favicon {\n      responsiveImage(imgixParams: {bg: \"00000000\", fm: png}) {\n        ...ResponsiveImageFields\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    query projectsStaticProps {\n  allProjects(orderBy: startDate_DESC) {\n    ...ProjectFragment\n  }\n}\n    ",
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    query websiteSeoTags {\n  about {\n    email\n    socials\n  }\n  site: _site {\n    favicon: faviconMetaTags(variants: [appleTouchIcon, icon, msApplication]) {\n      attributes\n      content\n      tag\n    }\n    seo: globalSeo {\n      fallback: fallbackSeo {\n        description\n        image {\n          url\n          width\n          height\n        }\n        title\n        twitterCard\n      }\n      siteName\n      titleSuffix\n      twitterAccount\n    }\n  }\n}\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
export var ColorBucketType;
(function(ColorBucketType) {
    ColorBucketType["Red"] = 'red';
    ColorBucketType["Orange"] = 'orange';
    ColorBucketType["Pink"] = 'pink';
    ColorBucketType["Cyan"] = 'cyan';
    ColorBucketType["Purple"] = 'purple';
    ColorBucketType["Blue"] = 'blue';
    ColorBucketType["Yellow"] = 'yellow';
    ColorBucketType["Green"] = 'green';
    ColorBucketType["Brown"] = 'brown';
    ColorBucketType["Grey"] = 'grey';
    ColorBucketType["White"] = 'white';
    ColorBucketType["Black"] = 'black';
})(ColorBucketType || (ColorBucketType = {}));
export var FaviconType;
(function(FaviconType) {
    FaviconType["Icon"] = 'icon';
    FaviconType["AppleTouchIcon"] = 'appleTouchIcon';
    FaviconType["MsApplication"] = 'msApplication';
})(FaviconType || (FaviconType = {}));
export var ImgixParamsAuto;
(function(ImgixParamsAuto) {
    ImgixParamsAuto["Enhance"] = 'enhance';
    ImgixParamsAuto["Format"] = 'format';
    ImgixParamsAuto["Redeye"] = 'redeye';
    ImgixParamsAuto["Compress"] = 'compress';
})(ImgixParamsAuto || (ImgixParamsAuto = {}));
export var ImgixParamsBlendAlign;
(function(ImgixParamsBlendAlign) {
    ImgixParamsBlendAlign["Top"] = 'top';
    ImgixParamsBlendAlign["Bottom"] = 'bottom';
    ImgixParamsBlendAlign["Middle"] = 'middle';
    ImgixParamsBlendAlign["Left"] = 'left';
    ImgixParamsBlendAlign["Right"] = 'right';
    ImgixParamsBlendAlign["Center"] = 'center';
})(ImgixParamsBlendAlign || (ImgixParamsBlendAlign = {}));
export var ImgixParamsBlendCrop;
(function(ImgixParamsBlendCrop) {
    ImgixParamsBlendCrop["Top"] = 'top';
    ImgixParamsBlendCrop["Bottom"] = 'bottom';
    ImgixParamsBlendCrop["Left"] = 'left';
    ImgixParamsBlendCrop["Right"] = 'right';
    ImgixParamsBlendCrop["Faces"] = 'faces';
})(ImgixParamsBlendCrop || (ImgixParamsBlendCrop = {}));
export var ImgixParamsBlendFit;
(function(ImgixParamsBlendFit) {
    ImgixParamsBlendFit["Clamp"] = 'clamp';
    ImgixParamsBlendFit["Clip"] = 'clip';
    ImgixParamsBlendFit["Crop"] = 'crop';
    ImgixParamsBlendFit["Scale"] = 'scale';
    ImgixParamsBlendFit["Max"] = 'max';
})(ImgixParamsBlendFit || (ImgixParamsBlendFit = {}));
export var ImgixParamsBlendMode;
(function(ImgixParamsBlendMode) {
    ImgixParamsBlendMode["Color"] = 'color';
    ImgixParamsBlendMode["Burn"] = 'burn';
    ImgixParamsBlendMode["Dodge"] = 'dodge';
    ImgixParamsBlendMode["Darken"] = 'darken';
    ImgixParamsBlendMode["Difference"] = 'difference';
    ImgixParamsBlendMode["Exclusion"] = 'exclusion';
    ImgixParamsBlendMode["Hardlight"] = 'hardlight';
    ImgixParamsBlendMode["Hue"] = 'hue';
    ImgixParamsBlendMode["Lighten"] = 'lighten';
    ImgixParamsBlendMode["Luminosity"] = 'luminosity';
    ImgixParamsBlendMode["Multiply"] = 'multiply';
    ImgixParamsBlendMode["Overlay"] = 'overlay';
    ImgixParamsBlendMode["Saturation"] = 'saturation';
    ImgixParamsBlendMode["Screen"] = 'screen';
    ImgixParamsBlendMode["Softlight"] = 'softlight';
    ImgixParamsBlendMode["Normal"] = 'normal';
})(ImgixParamsBlendMode || (ImgixParamsBlendMode = {}));
export var ImgixParamsBlendSize;
(function(ImgixParamsBlendSize) {
    ImgixParamsBlendSize["Inherit"] = 'inherit';
})(ImgixParamsBlendSize || (ImgixParamsBlendSize = {}));
export var ImgixParamsCh;
(function(ImgixParamsCh) {
    ImgixParamsCh["Width"] = 'width';
    ImgixParamsCh["Dpr"] = 'dpr';
    ImgixParamsCh["SaveData"] = 'saveData';
})(ImgixParamsCh || (ImgixParamsCh = {}));
export var ImgixParamsCrop;
(function(ImgixParamsCrop) {
    ImgixParamsCrop["Top"] = 'top';
    ImgixParamsCrop["Bottom"] = 'bottom';
    ImgixParamsCrop["Left"] = 'left';
    ImgixParamsCrop["Right"] = 'right';
    ImgixParamsCrop["Faces"] = 'faces';
    ImgixParamsCrop["Entropy"] = 'entropy';
    ImgixParamsCrop["Edges"] = 'edges';
    ImgixParamsCrop["Focalpoint"] = 'focalpoint';
})(ImgixParamsCrop || (ImgixParamsCrop = {}));
export var ImgixParamsCs;
(function(ImgixParamsCs) {
    ImgixParamsCs["Srgb"] = 'srgb';
    ImgixParamsCs["Adobergb1998"] = 'adobergb1998';
    ImgixParamsCs["Tinysrgb"] = 'tinysrgb';
    ImgixParamsCs["Strip"] = 'strip';
})(ImgixParamsCs || (ImgixParamsCs = {}));
export var ImgixParamsFill;
(function(ImgixParamsFill) {
    ImgixParamsFill["Solid"] = 'solid';
    ImgixParamsFill["Blur"] = 'blur';
})(ImgixParamsFill || (ImgixParamsFill = {}));
export var ImgixParamsFit;
(function(ImgixParamsFit) {
    ImgixParamsFit["Clamp"] = 'clamp';
    ImgixParamsFit["Clip"] = 'clip';
    ImgixParamsFit["Crop"] = 'crop';
    ImgixParamsFit["Facearea"] = 'facearea';
    ImgixParamsFit["Fill"] = 'fill';
    ImgixParamsFit["Fillmax"] = 'fillmax';
    ImgixParamsFit["Max"] = 'max';
    ImgixParamsFit["Min"] = 'min';
    ImgixParamsFit["Scale"] = 'scale';
})(ImgixParamsFit || (ImgixParamsFit = {}));
export var ImgixParamsFlip;
(function(ImgixParamsFlip) {
    ImgixParamsFlip["H"] = 'h';
    ImgixParamsFlip["V"] = 'v';
    ImgixParamsFlip["Hv"] = 'hv';
})(ImgixParamsFlip || (ImgixParamsFlip = {}));
export var ImgixParamsFm;
(function(ImgixParamsFm) {
    ImgixParamsFm["Gif"] = 'gif';
    ImgixParamsFm["Jpg"] = 'jpg';
    ImgixParamsFm["Jp2"] = 'jp2';
    ImgixParamsFm["Json"] = 'json';
    ImgixParamsFm["Jxr"] = 'jxr';
    ImgixParamsFm["Pjpg"] = 'pjpg';
    ImgixParamsFm["Mp4"] = 'mp4';
    ImgixParamsFm["Png"] = 'png';
    ImgixParamsFm["Png8"] = 'png8';
    ImgixParamsFm["Png32"] = 'png32';
    ImgixParamsFm["Webp"] = 'webp';
    ImgixParamsFm["Webm"] = 'webm';
})(ImgixParamsFm || (ImgixParamsFm = {}));
export var ImgixParamsMarkAlign;
(function(ImgixParamsMarkAlign) {
    ImgixParamsMarkAlign["Top"] = 'top';
    ImgixParamsMarkAlign["Middle"] = 'middle';
    ImgixParamsMarkAlign["Bottom"] = 'bottom';
    ImgixParamsMarkAlign["Left"] = 'left';
    ImgixParamsMarkAlign["Center"] = 'center';
    ImgixParamsMarkAlign["Right"] = 'right';
})(ImgixParamsMarkAlign || (ImgixParamsMarkAlign = {}));
export var ImgixParamsMarkFit;
(function(ImgixParamsMarkFit) {
    ImgixParamsMarkFit["Clip"] = 'clip';
    ImgixParamsMarkFit["Crop"] = 'crop';
    ImgixParamsMarkFit["Fill"] = 'fill';
    ImgixParamsMarkFit["Max"] = 'max';
    ImgixParamsMarkFit["Scale"] = 'scale';
})(ImgixParamsMarkFit || (ImgixParamsMarkFit = {}));
export var ImgixParamsPalette;
(function(ImgixParamsPalette) {
    ImgixParamsPalette["Css"] = 'css';
    ImgixParamsPalette["Json"] = 'json';
})(ImgixParamsPalette || (ImgixParamsPalette = {}));
export var ImgixParamsTransparency;
(function(ImgixParamsTransparency) {
    ImgixParamsTransparency["Grid"] = 'grid';
})(ImgixParamsTransparency || (ImgixParamsTransparency = {}));
export var ImgixParamsTrim;
(function(ImgixParamsTrim) {
    ImgixParamsTrim["Auto"] = 'auto';
    ImgixParamsTrim["Color"] = 'color';
})(ImgixParamsTrim || (ImgixParamsTrim = {}));
export var ImgixParamsTxtAlign;
(function(ImgixParamsTxtAlign) {
    ImgixParamsTxtAlign["Top"] = 'top';
    ImgixParamsTxtAlign["Middle"] = 'middle';
    ImgixParamsTxtAlign["Bottom"] = 'bottom';
    ImgixParamsTxtAlign["Left"] = 'left';
    ImgixParamsTxtAlign["Center"] = 'center';
    ImgixParamsTxtAlign["Right"] = 'right';
})(ImgixParamsTxtAlign || (ImgixParamsTxtAlign = {}));
export var ImgixParamsTxtClip;
(function(ImgixParamsTxtClip) {
    ImgixParamsTxtClip["Start"] = 'start';
    ImgixParamsTxtClip["Middle"] = 'middle';
    ImgixParamsTxtClip["End"] = 'end';
    ImgixParamsTxtClip["Ellipsis"] = 'ellipsis';
})(ImgixParamsTxtClip || (ImgixParamsTxtClip = {}));
export var ImgixParamsTxtFit;
(function(ImgixParamsTxtFit) {
    ImgixParamsTxtFit["Max"] = 'max';
})(ImgixParamsTxtFit || (ImgixParamsTxtFit = {}));
export var ItemStatus;
(function(ItemStatus) {
    ItemStatus["Draft"] = 'draft';
    ItemStatus["Updated"] = 'updated';
    ItemStatus["Published"] = 'published';
})(ItemStatus || (ItemStatus = {}));
export var MuxThumbnailFormatType;
(function(MuxThumbnailFormatType) {
    MuxThumbnailFormatType["Jpg"] = 'jpg';
    MuxThumbnailFormatType["Png"] = 'png';
    MuxThumbnailFormatType["Gif"] = 'gif';
})(MuxThumbnailFormatType || (MuxThumbnailFormatType = {}));
export var PostModelOrderBy;
(function(PostModelOrderBy) {
    PostModelOrderBy["CreatedAtAsc"] = '_createdAt_ASC';
    PostModelOrderBy["CreatedAtDesc"] = '_createdAt_DESC';
    PostModelOrderBy["CreatedAtAsc"] = 'createdAt_ASC';
    PostModelOrderBy["CreatedAtDesc"] = 'createdAt_DESC';
    PostModelOrderBy["IdAsc"] = 'id_ASC';
    PostModelOrderBy["IdDesc"] = 'id_DESC';
    PostModelOrderBy["FirstPublishedAtAsc"] = '_firstPublishedAt_ASC';
    PostModelOrderBy["FirstPublishedAtDesc"] = '_firstPublishedAt_DESC';
    PostModelOrderBy["PublicationScheduledAtAsc"] = '_publicationScheduledAt_ASC';
    PostModelOrderBy["PublicationScheduledAtDesc"] = '_publicationScheduledAt_DESC';
    PostModelOrderBy["UnpublishingScheduledAtAsc"] = '_unpublishingScheduledAt_ASC';
    PostModelOrderBy["UnpublishingScheduledAtDesc"] = '_unpublishingScheduledAt_DESC';
    PostModelOrderBy["PublishedAtAsc"] = '_publishedAt_ASC';
    PostModelOrderBy["PublishedAtDesc"] = '_publishedAt_DESC';
    PostModelOrderBy["StatusAsc"] = '_status_ASC';
    PostModelOrderBy["StatusDesc"] = '_status_DESC';
    PostModelOrderBy["UpdatedAtAsc"] = '_updatedAt_ASC';
    PostModelOrderBy["UpdatedAtDesc"] = '_updatedAt_DESC';
    PostModelOrderBy["UpdatedAtAsc"] = 'updatedAt_ASC';
    PostModelOrderBy["UpdatedAtDesc"] = 'updatedAt_DESC';
    PostModelOrderBy["IsValidAsc"] = '_isValid_ASC';
    PostModelOrderBy["IsValidDesc"] = '_isValid_DESC';
})(PostModelOrderBy || (PostModelOrderBy = {}));
export var ProjectModelOrderBy;
(function(ProjectModelOrderBy) {
    ProjectModelOrderBy["CreatedAtAsc"] = '_createdAt_ASC';
    ProjectModelOrderBy["CreatedAtDesc"] = '_createdAt_DESC';
    ProjectModelOrderBy["CreatedAtAsc"] = 'createdAt_ASC';
    ProjectModelOrderBy["CreatedAtDesc"] = 'createdAt_DESC';
    ProjectModelOrderBy["IdAsc"] = 'id_ASC';
    ProjectModelOrderBy["IdDesc"] = 'id_DESC';
    ProjectModelOrderBy["FirstPublishedAtAsc"] = '_firstPublishedAt_ASC';
    ProjectModelOrderBy["FirstPublishedAtDesc"] = '_firstPublishedAt_DESC';
    ProjectModelOrderBy["PublicationScheduledAtAsc"] = '_publicationScheduledAt_ASC';
    ProjectModelOrderBy["PublicationScheduledAtDesc"] = '_publicationScheduledAt_DESC';
    ProjectModelOrderBy["UnpublishingScheduledAtAsc"] = '_unpublishingScheduledAt_ASC';
    ProjectModelOrderBy["UnpublishingScheduledAtDesc"] = '_unpublishingScheduledAt_DESC';
    ProjectModelOrderBy["PublishedAtAsc"] = '_publishedAt_ASC';
    ProjectModelOrderBy["PublishedAtDesc"] = '_publishedAt_DESC';
    ProjectModelOrderBy["StatusAsc"] = '_status_ASC';
    ProjectModelOrderBy["StatusDesc"] = '_status_DESC';
    ProjectModelOrderBy["UpdatedAtAsc"] = '_updatedAt_ASC';
    ProjectModelOrderBy["UpdatedAtDesc"] = '_updatedAt_DESC';
    ProjectModelOrderBy["UpdatedAtAsc"] = 'updatedAt_ASC';
    ProjectModelOrderBy["UpdatedAtDesc"] = 'updatedAt_DESC';
    ProjectModelOrderBy["IsValidAsc"] = '_isValid_ASC';
    ProjectModelOrderBy["IsValidDesc"] = '_isValid_DESC';
    ProjectModelOrderBy["EndDateAsc"] = 'endDate_ASC';
    ProjectModelOrderBy["EndDateDesc"] = 'endDate_DESC';
    ProjectModelOrderBy["StartDateAsc"] = 'startDate_ASC';
    ProjectModelOrderBy["StartDateDesc"] = 'startDate_DESC';
    ProjectModelOrderBy["UrlAsc"] = 'url_ASC';
    ProjectModelOrderBy["UrlDesc"] = 'url_DESC';
    ProjectModelOrderBy["TitleAsc"] = 'title_ASC';
    ProjectModelOrderBy["TitleDesc"] = 'title_DESC';
})(ProjectModelOrderBy || (ProjectModelOrderBy = {}));
export var ResolutionType;
(function(ResolutionType) {
    ResolutionType["Icon"] = 'icon';
    ResolutionType["Small"] = 'small';
    ResolutionType["Medium"] = 'medium';
    ResolutionType["Large"] = 'large';
})(ResolutionType || (ResolutionType = {}));
export var SiteLocale;
(function(SiteLocale) {
    SiteLocale["En"] = 'en';
})(SiteLocale || (SiteLocale = {}));
export var UploadOrderBy;
(function(UploadOrderBy) {
    UploadOrderBy["CreatedAtAsc"] = '_createdAt_ASC';
    UploadOrderBy["CreatedAtDesc"] = '_createdAt_DESC';
    UploadOrderBy["SizeAsc"] = 'size_ASC';
    UploadOrderBy["SizeDesc"] = 'size_DESC';
    UploadOrderBy["ResolutionAsc"] = 'resolution_ASC';
    UploadOrderBy["ResolutionDesc"] = 'resolution_DESC';
    UploadOrderBy["FilenameAsc"] = 'filename_ASC';
    UploadOrderBy["FilenameDesc"] = 'filename_DESC';
    UploadOrderBy["BasenameAsc"] = 'basename_ASC';
    UploadOrderBy["BasenameDesc"] = 'basename_DESC';
    UploadOrderBy["MimeTypeAsc"] = 'mimeType_ASC';
    UploadOrderBy["MimeTypeDesc"] = 'mimeType_DESC';
    UploadOrderBy["FormatAsc"] = 'format_ASC';
    UploadOrderBy["FormatDesc"] = 'format_DESC';
    UploadOrderBy["UpdatedAtAsc"] = '_updatedAt_ASC';
    UploadOrderBy["UpdatedAtDesc"] = '_updatedAt_DESC';
    UploadOrderBy["IdAsc"] = 'id_ASC';
    UploadOrderBy["IdDesc"] = 'id_DESC';
})(UploadOrderBy || (UploadOrderBy = {}));
export var UploadOrientation;
(function(UploadOrientation) {
    UploadOrientation["Landscape"] = 'landscape';
    UploadOrientation["Portrait"] = 'portrait';
    UploadOrientation["Square"] = 'square';
})(UploadOrientation || (UploadOrientation = {}));
export var UploadType;
(function(UploadType) {
    UploadType["Image"] = 'image';
    UploadType["Audio"] = 'audio';
    UploadType["Video"] = 'video';
    UploadType["Richtext"] = 'richtext';
    UploadType["Presentation"] = 'presentation';
    UploadType["Spreadsheet"] = 'spreadsheet';
    UploadType["Pdfdocument"] = 'pdfdocument';
    UploadType["Archive"] = 'archive';
})(UploadType || (UploadType = {}));
export var VideoMp4Res;
(function(VideoMp4Res) {
    VideoMp4Res["Low"] = 'low';
    VideoMp4Res["Medium"] = 'medium';
    VideoMp4Res["High"] = 'high';
})(VideoMp4Res || (VideoMp4Res = {}));
export var ResponsiveImageFieldsFragmentDoc = /*#__PURE__*/ gql(_templateObject());
export var ProjectFragmentDoc = /*#__PURE__*/ gql(_templateObject1(), ResponsiveImageFieldsFragmentDoc);
export var AboutStaticPropsDocument = /*#__PURE__*/ gql(_templateObject2(), ResponsiveImageFieldsFragmentDoc);
export var HomeStaticPropsDocument = /*#__PURE__*/ gql(_templateObject3(), ResponsiveImageFieldsFragmentDoc);
export var ProjectsStaticPropsDocument = /*#__PURE__*/ gql(_templateObject4(), ProjectFragmentDoc);
export var WebsiteSeoTagsDocument = /*#__PURE__*/ gql(_templateObject5());
var defaultWrapper = function(action, _operationName) {
    return action();
};
export function getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultWrapper;
    return {
        aboutStaticProps: function aboutStaticProps(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(AboutStaticPropsDocument, variables, _objectSpread({}, requestHeaders, wrappedRequestHeaders));
            }, 'aboutStaticProps');
        },
        homeStaticProps: function homeStaticProps(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(HomeStaticPropsDocument, variables, _objectSpread({}, requestHeaders, wrappedRequestHeaders));
            }, 'homeStaticProps');
        },
        projectsStaticProps: function projectsStaticProps(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(ProjectsStaticPropsDocument, variables, _objectSpread({}, requestHeaders, wrappedRequestHeaders));
            }, 'projectsStaticProps');
        },
        websiteSeoTags: function websiteSeoTags(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(WebsiteSeoTagsDocument, variables, _objectSpread({}, requestHeaders, wrappedRequestHeaders));
            }, 'websiteSeoTags');
        }
    };
}
